import { useAuthReadiness } from './contexts/AuthReadinessContext';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';

// Create router
const router = createBrowserRouter(routes);

export const AppContent = () => {
  const { isAuthReady, isLoading, error } = useAuthReadiness();

  if (isLoading || !isAuthReady) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
        < Box m={2}>Loading...</Box>
      </Box>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return <RouterProvider router={router} />;
};